import Vue from "vue";
import Vuex from "vuex";

import activity from "./modules/user-activity"
import chat from "./modules/uni-chat"
import goals from "./modules/goals"
import presence from './modules/user-presence'

Vue.use(Vuex);

const Store = new Vuex.Store ({
    modules: {
        activity,
        chat,
        goals,
        presence
    }
});

export default Store;